import cx from 'classnames'
import { useMemo } from 'react'

import {
  type Step,
  type StepState,
  getStepDefinitions,
} from '../../lib/step-definition'

interface DefinitionsProps {
  stepStates: Record<Step, StepState>
  showExtrasStep: boolean
  onDefinitionClose: () => void
  className?: string
}

const Definitions = ({
  stepStates,
  showExtrasStep,
  onDefinitionClose,
  className,
}: DefinitionsProps) => {
  const activeStepDefinitions = useMemo(() => {
    const stepDefinitions = getStepDefinitions(showExtrasStep)

    return stepDefinitions.filter(
      (stepDefinition) => stepStates[stepDefinition.step] !== 'closed',
    )
  }, [showExtrasStep, stepStates])

  return (
    <div className={cx('w-full', className)}>
      {activeStepDefinitions.map((stepDefinition) => (
        <stepDefinition.definitionComponent
          key={stepDefinition.step}
          number={stepDefinition.number}
          onClose={onDefinitionClose}
        />
      ))}
    </div>
  )
}

export default Definitions
